import { render } from "./MainButton.vue?vue&type=template&id=60f165b2&scoped=true"
const script = {}

import "./MainButton.vue?vue&type=style&index=0&id=60f165b2&lang=scss&scoped=true"

import exportComponent from "C:\\Frontend\\Projects\\interactive-card-details-form-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f165b2"]])

export default __exports__